import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
// need to import for it to work properly
import * as pdfjsLib from 'pdfjs-dist/webpack'; // eslint-disable-line

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const PdfViewer = ({ pdfUrl }) => {
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [numPages, setNumPages] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const [scale, setScale] = useState(1);

    const onLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (/mobi|android|iphone|ipad|ipod/i.test(userAgent)) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }

        const handleResize = () => {
            const newScale = Math.min(window.innerWidth / 1000, 1);
            setScale(newScale);
            setWindowHeight(window.innerHeight);
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            {
                isMobile ? (
                    <div className="pdf-container-mobile">
                        <Document
                            file={pdfUrl}
                            onLoadSuccess={onLoadSuccess}
                        >
                            {Array.from(new Array(numPages), (el, index) => (
                                <div key={index} className="pdf-page-mobile">
                                    <Page pageNumber={index + 1} scale={scale} />
                                </div>
                            ))}
                        </Document>
                    </div>
                ) : (
                    <div style={{ height: windowHeight, overflow: 'hidden' }}>
                        <iframe
                            src={pdfUrl}
                            type="application/pdf"
                            title="PDF Viewer"
                            width="100%"
                            height={windowHeight}
                        />
                    </div>
                )
            }
        </>
    );
}

export default PdfViewer;